var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2223_10651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2274 8.29199H0V16.7826H11.5527V9.82032H6.53786V8.702L6.94786 8.29199H6.53786V8.702L6.12364 9.11622L5.7634 8.756L6.2274 8.29199ZM4.63638 14.1263C4.58292 14.2565 4.64509 14.4053 4.77521 14.4587C4.90534 14.5122 5.05416 14.45 5.1076 14.3199L6.51474 10.8938C6.56818 10.7637 6.50603 10.6149 6.37589 10.5614C6.24576 10.508 6.09696 10.5701 6.0435 10.7003L4.63638 14.1263ZM4.13129 13.8444C4.04358 13.9544 3.88333 13.9725 3.77333 13.8847L2.36773 12.7641C2.30736 12.716 2.27208 12.6431 2.27179 12.5659C2.27152 12.4887 2.30624 12.4155 2.36624 12.367L3.82773 11.1839C3.93708 11.0953 4.09746 11.1122 4.18599 11.2216C4.27449 11.3309 4.25761 11.4913 4.14827 11.5798L2.9332 12.5634L4.09091 13.4864C4.20089 13.5741 4.21898 13.7344 4.13129 13.8444ZM7.19783 13.8444C7.28552 13.9544 7.44579 13.9725 7.55579 13.8847L8.96138 12.7641C9.02175 12.716 9.05702 12.6431 9.05731 12.5659C9.0576 12.4887 9.02287 12.4155 8.96286 12.367L7.50138 11.1839C7.39204 11.0953 7.23164 11.1122 7.14313 11.2216C7.05463 11.3309 7.0715 11.4913 7.18085 11.5798L8.3959 12.5634L7.23821 13.4864C7.1282 13.5741 7.11014 13.7344 7.19783 13.8444Z",
    fill: "#4C5E6E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53701 1.5H18.0842V9.29072L14.019 5.22554C13.9227 5.12921 13.7676 5.12574 13.667 5.21768L12.3591 6.41346L10.3911 4.48448C10.2914 4.38671 10.1315 4.38751 10.0327 4.48627L6.53701 7.98197V1.5ZM6.53701 8.29242V7.98197L6.22656 8.29242H6.53701ZM6.94702 8.29242L10.2146 5.02481L12.1747 6.94605L12.1757 6.947L13.5767 8.30551L13.9313 7.93979L12.7246 6.7696L13.831 5.758L17.8938 9.82076H11.5519V8.29242H6.94702ZM17.8938 9.82076L18.2436 10.1707L18.604 9.81045L18.0842 9.29072V9.82076H17.8938ZM16.2163 4.72642C16.779 4.72642 17.2351 4.27025 17.2351 3.70755C17.2351 3.14484 16.779 2.68868 16.2163 2.68868C15.6536 2.68868 15.1974 3.14484 15.1974 3.70755C15.1974 4.27025 15.6536 4.72642 16.2163 4.72642Z",
    fill: "#4C5E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2223_10651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidence);
export default __webpack_public_path__ + "static/media/evidence.426d39b9.svg";
export { ForwardRef as ReactComponent };